<div class="case-tooth-dialog-root">
  @if (isLoading) {
    <div class="case-tooth-dialog-loader" data-cy="organizer-case-tooth-loader">
      <mat-spinner diameter="100"></mat-spinner>
    </div>
  }
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;">
      <div class="section-header-title" data-cy="organizer-case-tooth-title">
        Change Case / Tooth
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; overflow-y: hidden;">
      <div style="display: flex; flex-direction: column; height: 100%;">
        <div style="flex: 1; display: flex; flex-direction: column; height: 100%; max-height: 100%; overflow-y: hidden;">
          <div style="flex-basis: fit-content; font-weight: 500; color: var(--tdo-primary-accent);" data-cy="organizer-cases-label">Cases:</div>
          <div style="display: flex; font-weight: 500; font-size: 14px;" data-cy="organizer-case-header">
            <div style="flex: 1;" data-cy="organizer-case-description-header">Description</div>
            <div style="flex: 1;" data-cy="organizer-case-teeth-header">Teeth</div>
            <div style="flex: 1;" data-cy="organizer-case-date-header">Date</div>
          </div>
          <div style="flex: 1; overflow-y: auto; display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="organizer-cases-container">
            @for (cse of cases; track cse.PatientCaseId) {
              <button
                type="button"
                (click)="onCaseClick(cse)"
                class="case-tooth-dialog-item"
                [disabled]="isLoading"
                [class.case-tooth-dialog-item-selected]="!!selectedCase && selectedCase.PatientCaseId === cse.PatientCaseId"
                data-cy="organizer-case-item">
                <div style="display: flex;">
                  <div style="flex: 1;" data-cy="organizer-case-description">{{cse.Description}}</div>
                  <div style="flex: 1;" data-cy="organizer-case-teeth">{{cse.Teeth}}</div>
                  <div style="flex: 1;" data-cy="organizer-case-date">{{cse.DateString}}</div>
                </div>
              </button>
            }
          </div>
        </div>
        <div style="flex-basis: 80px; min-height: 80px; display: flex; flex-direction: column;">
          <div style="flex-basis: fit-content; font-weight: 500; color: var(--tdo-primary-accent);" data-cy="organizer-teeth-label">Teeth:</div>
          <div style="flex: 1; overflow-y: auto; display: flex; flex-wrap: wrap; height: 100%; max-height: 100%; margin-top: 6px;" data-cy="organizer-teeth-container">
            @for (tooth of selectedCase?.DataTeethIdsList; track tooth) {
              <div>
                @if (tooth.Notation) {
                  <div>
                    <mat-checkbox #cb [checked]="isChecked(tooth)" (change)="onCheckboxChange($event, tooth, cb)" labelPosition="before" style="margin-right: 20px;" [disabled]="isLoading" data-cy="organizer-tooth-checkbox">{{tooth.Notation}}</mat-checkbox>
                  </div>
                }
              </div>
            }
            @if (selectedCase?.TeethList?.length === 0) {
              <div style="width: 100%; text-align: center;" data-cy="organizer-no-teeth-message">
                No teeth assigned to case.  You must assign teeth to this case first.
              </div>
            }
          </div>
        </div>
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 6px;">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="organizer-cancel-button">Cancel</button>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" [disabled]="isLoading" data-cy="organizer-ok-button">Ok</button>
    </div>
  </div>
</div>
